import React, { useState } from "react";
import {
  IonIcon,
  IonImg,
} from "@ionic/react";
import {
  logOutOutline,
  menuOutline,
  homeOutline,
  personOutline,
  calendarOutline,
  documentTextOutline,
  medicalOutline,
  timeOutline,
  peopleOutline,
} from "ionicons/icons";
import "./Menu.css";
import useMenu from "./useMenu";
import { Typography } from "@mui/joy";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    icon: homeOutline,
  },
  {
    title: "Mis Datos",
    url: "/portal/Datos",
    icon: personOutline,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    icon: calendarOutline,
  },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    icon: medicalOutline,
  },
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    icon: documentTextOutline,
  },
];

const HeaderMenu = (props) => {
  const { usuario, mostrarNotificacion, cerrarSesion } = useMenu();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    closeMenu(); // Cerrar el menú primero
    cerrarSesion(); // Luego cerrar sesión
  };

  return (
    <header className="tech-header">
      <div className="tech-header-logo-container">
        <IonImg
          src={props.logoSrc || "assets/icon/logo.jpg"}
          className="tech-header-logo"
        />
        <Typography className="tech-header-title">
          Portal Pacientes
        </Typography>
      </div>

      {/* Menú horizontal para pantallas grandes */}
      <nav className="menu-horizontal tech-header-nav">
        {appPages.map((appPage, index) => (
          <a
            key={index}
            href={appPage.url}
            className="tech-header-link"
            onMouseEnter={(e) => (e.target.style.color = "#28A745")}
            onMouseLeave={(e) => (e.target.style.color = "white")}
          >
            {appPage.title}
          </a>
        ))}
      </nav>

      {/* Botón hamburguesa para pantallas pequeñas */}
      <IonIcon
        icon={menuOutline}
        className="menu-hamburguesa tech-header-hamburguesa"
        onClick={toggleMenu}
      />

      {/* Menú desplegable */}
      {isMenuOpen && (
        <div className="menu-desplegable tech-header-dropdown">
          {appPages.map((appPage, index) => (
            <a
              key={index}
              href={appPage.url}
              className="menu-item tech-header-dropdown-link"
              onClick={closeMenu}
              onMouseEnter={(e) => {
                e.target.style.background = "linear-gradient(135deg, #a70101, #c91e1e)";
                e.target.style.color = "white";
                e.target.style.transform = "translateX(10px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#212529";
                e.target.style.transform = "translateX(0)";
              }}
            >
              <IonIcon 
                icon={appPage.icon} 
                className="tech-header-dropdown-icon"
              />
              {appPage.title}
            </a>
          ))}
          {/* Separador y opción de cerrar sesión */}
          <div className="tech-header-dropdown-separator" />
          <button
            className="menu-item logout-item tech-header-dropdown-logout"
            onClick={handleLogout}
            onMouseEnter={(e) => {
              e.target.style.background = "linear-gradient(135deg, #dc3545, #c82333)";
              e.target.style.color = "white";
              e.target.style.transform = "translateX(10px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#dc3545";
              e.target.style.transform = "translateX(0)";
            }}
          >
            <IonIcon 
              icon={logOutOutline} 
              className="tech-header-dropdown-logout-icon"
            />
            Cerrar Sesión
          </button>
        </div>
      )}

      <div
        className="tech-header-logout"
        onClick={cerrarSesion}
        onMouseEnter={e => {
          e.currentTarget.style.background = "linear-gradient(90deg, #dc3545 0%, #c82333 100%)";
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(220,53,69,0.25)";
          // Cambiar el color del texto a blanco solo en hover
          const children = e.currentTarget.children;
          if (children.length > 0) {
            // Typography puede tener un span como primer hijo
            const textNode = children[0].querySelector('span') || children[0];
            textNode.style.color = "#fff";
          }
          if (children.length > 1) {
            children[1].style.color = "#fff";
          }
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = "linear-gradient(90deg, #ffdde1 0%, #ee9ca7 100%)";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(220,53,69,0.15)";
          // Restaurar el color original solo al texto
          const children = e.currentTarget.children;
          if (children.length > 0) {
            const textNode = children[0].querySelector('span') || children[0];
            textNode.style.color = "#dc3545";
          }
          if (children.length > 1) {
            children[1].style.color = "#dc3545";
          }
        }}
        title="Cerrar Sesión"
      >
        <Typography
          className="tech-header-logout-text"
        >
          Cerrar Sesión
        </Typography>
        <IonIcon
          icon={logOutOutline}
          className="tech-header-logout-icon"
        />
      </div>
    </header>
  );
};

export default HeaderMenu;
